﻿import { useTranslation } from "react-i18next";
import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import Breadcrumb from "./components/Breadcrumb";
import Hero from "./components/Hero";
import TableOfContents from "@/pages/blog/isde-subsidie-2026/components/TableOfContents";
import ArticleContent from "./components/ArticleContent";
import FAQ from "./components/FAQ";
import Disclaimer from "./components/Disclaimer";

export default function BlogCondensPage() {
  const { t } = useTranslation("blog-condens");

  const faqItems = t("faq.items", { returnObjects: true }) as Array<{
    q: string;
    a: string;
  }>;

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: t("schema.headline"),
    description: t("schema.description"),
    author: {
      "@type": "Organization",
      name: t("schema.author"),
      url: "https://ramen-repair-eindhoven.nl/",
    },
    publisher: {
      "@type": "Organization",
      name: "Ramen Repair Eindhoven",
      url: "https://ramen-repair-eindhoven.nl/",
    },
    datePublished: t("schema.datePublished"),
    dateModified: t("schema.dateModified"),
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://ramen-repair-eindhoven.nl/blog/condens-ramen-oplossen/",
    },
    image: t("hero.image"),
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://ramen-repair-eindhoven.nl/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Blog",
        item: "https://ramen-repair-eindhoven.nl/blog/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Condens op ramen",
        item: "https://ramen-repair-eindhoven.nl/blog/condens-ramen-oplossen/",
      },
    ],
  };

  return (
    <>
      <title>{t("meta.title")}</title>
      <meta name="description" content={t("meta.description")} />

      <script type="application/ld+json">{JSON.stringify(articleSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>

      <Header />
      <main>
        <Breadcrumb />
        <Hero />
        <div className="max-w-[1024px] mx-auto px-4 md:px-6 py-10 md:py-16">
          <TableOfContents />
          <ArticleContent />
          <div className="mt-10 md:mt-14">
            <FAQ />
          </div>
          {/* CTA */}
          <div className="mt-10 md:mt-14 bg-brand-text rounded-2xl p-6 md:p-10 text-white">
            <h3 className="font-geist font-bold text-lg md:text-xl text-white mb-3">
              {t("cta.text")}
            </h3>
            <a
              href="tel:+31407987470"
              className="inline-flex items-center gap-2 font-geist font-bold text-sm bg-brand-yellow text-brand-text px-6 py-3 rounded-full hover:bg-brand-yellow/90 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center text-sm"></i>
              {t("cta.phone")}
            </a>
          </div>
          <div className="mt-10 md:mt-14">
            <Disclaimer />
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}